import { createEntityAdapter } from '@reduxjs/toolkit';
import { getSensorUniqueKey } from '@utils/sensors/sensors.utils';

import { SensorConfiguration } from '@/types/sensor/configuration.types';

export const sensorsAdapter = createEntityAdapter<SensorConfiguration, string>({
  selectId: getSensorUniqueKey,
  sortComparer: (objectA, objectB) => getSensorUniqueKey(objectA).localeCompare(getSensorUniqueKey(objectB)),
});
